import React, { ReactElement } from 'react';

import { LinkButton, StandardButton } from '@eika/button';
import IconTypes from '@eika/icon/lib/IconTypes';

interface Props {
    showPrevious?: boolean;
    showNext?: boolean;
    nextButtonType?: 'submit' | 'reset' | 'button';
    nextButtonName?: string | ReactElement;
    previousButtonName?: string;
    previousChangeEvent?: () => void;
    nextChangeEvent?: () => void;
}

const StepButtons = ({
    showPrevious = false,
    showNext = true,
    nextButtonType = 'button',
    nextButtonName = 'Neste',
    previousButtonName = 'Tilbake',
    previousChangeEvent,
    nextChangeEvent,
}: Props): JSX.Element => (
    <div className="step-buttons">
        {showPrevious && (
            <LinkButton
                className="previous-button"
                onClick={previousChangeEvent && previousChangeEvent}
                icon={IconTypes.LITEN_PIL_VENSTRE}
            >
                {previousButtonName}
            </LinkButton>
        )}
        {showNext && (
            <StandardButton className="next-button" type={nextButtonType} onClick={nextChangeEvent && nextChangeEvent}>
                {nextButtonName}
            </StandardButton>
        )}
    </div>
);

export default StepButtons;
